// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--townsquare/townsquare-screen-space-flags';

import { MessageFrontend as createMessageFrontendTownsquareTopNavUniversalCreateSpotlight } from '@post-office/browser--navx/townsquare-top-nav-universal-create-spotlight/placements/in-app-v2/townsquare-screen-space-flags';
import { MessageFrontend as createMessageFrontendTownsquareTwcModal } from '@post-office/browser--growth-starburst/townsquare-twc-modal/placements/in-app-v2/townsquare-screen-space-flags';
import { MessageFrontend as createMessageFrontendTownsquareTwcSpotlight } from '@post-office/browser--growth-starburst/townsquare-twc-spotlight/placements/in-app-v2/townsquare-screen-space-flags';
import { MessageFrontend as createMessageFrontendHomeAppChangeboardingPopups } from '@post-office/browser--townsquare/home-app-changeboarding-popups/placements/in-app-v2/townsquare-screen-space-flags';
import { MessageFrontend as createMessageFrontendTwcXflowModalV2 } from '@post-office/browser--growth-starburst/twc-xflow-modal-v2/placements/in-app-v2/townsquare-screen-space-flags';
import { MessageFrontend as createMessageFrontendSharedUserPreferencesOnboarding } from '@post-office/browser--design-system/shared-user-preferences-onboarding/placements/in-app-v2/townsquare-screen-space-flags';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementFrontendProps } from '@post-office/browser--townsquare/townsquare-screen-space-flags';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendTownsquareTopNavUniversalCreateSpotlight({
		messageTemplateId: 'townsquare-top-nav-universal-create-spotlight',
	}),
	createMessageFrontendTownsquareTwcModal({ messageTemplateId: 'townsquare-twc-modal' }),
	createMessageFrontendTownsquareTwcSpotlight({ messageTemplateId: 'townsquare-twc-spotlight' }),
	createMessageFrontendHomeAppChangeboardingPopups({
		messageTemplateId: 'home-app-changeboarding-popups',
	}),
	createMessageFrontendTwcXflowModalV2({ messageTemplateId: 'twc-xflow-modal-v2' }),
	createMessageFrontendSharedUserPreferencesOnboarding({
		messageTemplateId: 'shared-user-preferences-onboarding',
	}),
];

export const RawPlacement: PlacementRendererStage<PlacementFrontendProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementFrontendProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementFrontendProps> = RawPlacement;
